import React from "react";

function EditClass({ data }) {
  return (
    <div>
      <div className="d-flex align-items-center">
        <i className="fas fa-dumbbell" />
        <button
          className="btn"
          to="/User/ClassList/ClassInfoEdit"
          onClick={() => {
            // history.push({
            //   pathname: "/User/ClassList/ClassInfoEdit",
            //   state: { data: data[0] },
            // });
          }}
        >
          ویرایش اطلاعات کلاس
        </button>
      </div>
      <div className="d-flex align-items-center">
        <i className="far fa-clock" />
        <button
          className="btn"
          onClick={() => {
            // history.push({
            //   pathname: "/User/ClassList/TimeEdit",
            //   state: { data: data[0].details_session },
            // });
          }}
        >
          ویرایش زمانبندی
        </button>
      </div>
      <div className="d-flex align-items-center">
        <i className="fas fa-chalkboard-teacher" />
        <button
          className="btn"
          onClick={() => {
            // history.push({
            //   pathname: "/User/ClassList/TeachersEdit",
            //   state: { data: data[0].teachers },
            // });
          }}
        >
          ویرایش مدرسین
        </button>
      </div>
      <div className="d-flex align-items-center">
        <i className="fas fa-tag" />
        <button
          className="btn"
          onClick={() => {
            // history.push({
            //   pathname: "/User/ClassList/TagSeo",
            //   state: { data: data[0] },
            // });
          }}
        >
          ویرایش تگ ها
        </button>
      </div>
    </div>
  );
}

export default EditClass;
